import { ComponentRef, Directive, inject, Input, OnInit } from '@angular/core';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { takeUntil } from 'rxjs/operators';
import { ProjectsListContextMenuComponent } from '../components/projects-list-context-menu/projects-list-context-menu.component';
import { ProjectListStateService } from '../services/project-list-state.service';

@Directive({
  selector: '[appProjectsListContextMenu]',
  standalone: false,
})
export class ProjectsListContextMenuDirective extends ContextMenuDirective implements OnInit {
  @Input() appProjectsListContextMenuWithAdvancedSearch: boolean;
  @Input() appProjectsListContextMenuWithScore: boolean;
  @Input() appProjectsListContextMenuWithSidebarFilters = false;
  @Input() stchPopoverTrigger: PopoverTrigger = 'click';
  @Input() stchPopoverPlacement: PopoverPlacement = 'bottomLeft';

  private readonly projectListStateService = inject(ProjectListStateService);

  protected override registerInstance(componentRef: ComponentRef<ProjectsListContextMenuComponent>) {
    componentRef.instance.state = this.projectListStateService.state;
    componentRef.instance.withAdvancedSearch = this.appProjectsListContextMenuWithAdvancedSearch;
    componentRef.instance.withScore = this.appProjectsListContextMenuWithScore;
    componentRef.instance.withSidebarFilters = this.appProjectsListContextMenuWithSidebarFilters;
  }

  protected override registerComponent() {
    return ProjectsListContextMenuComponent;
  }

  public override ngOnInit() {
    super.ngOnInit();

    this.projectListStateService
      .value()
      .pipe(takeUntil(this.alive))
      .subscribe((listState) => {
        this.isDefaultStateObservable?.next(listState.isDefault());
      });

    if (!this.isDefaultStateObservable) {
      return;
    }

    this.isDefaultStateObservable.pipe(takeUntil(this.alive)).subscribe((isDefault) => {
      if (isDefault && !this.projectListStateService.state.isDefault()) {
        this.projectListStateService.state.resetToDefault();
      }
    });
  }
}
